/* eslint-disable @typescript-eslint/ban-types */
import React, { SyntheticEvent } from 'react';
import { ColumnInstance } from 'react-table';

interface SelectColumnFilterInput<D extends object> {
    column: ColumnInstance<D>;
}

// This is a custom filter UI for selecting
// a unique option from a list
export function SelectColumnFilter<D extends object>({
    column,
}: SelectColumnFilterInput<D>): JSX.Element {
    const { filterValue, setFilter, preFilteredRows, id } = column;

    // Calculate the options for filtering
    // using the preFilteredRows
    const options: string[] = React.useMemo(() => {
        const optionsSet = new Set<string>();

        preFilteredRows.forEach(row => {
            const currentOption = row.values[id];

            if (typeof currentOption === 'string') {
                optionsSet.add(currentOption);
            }
        });

        return Array.from(optionsSet.values());
    }, [id, preFilteredRows]);

    // Render a multi-select box
    return (
        <select
            value={filterValue}
            onChange={(e: SyntheticEvent): void => {
                const inputValue = (e.target as HTMLInputElement)?.value;

                setFilter(inputValue);
            }}
        >
            <option value="">All</option>
            {options.map((option: string) => (
                <option key={option} value={option}>
                    {option}
                </option>
            ))}
        </select>
    );
}
